module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_8011.e11bfba7.png";